<!--<app-sidebar-navigation></app-sidebar-navigation>-->
<!--  &lt;!&ndash;site header begins&ndash;&gt;-->
<!--  <app-header></app-header>-->
  <!--site header ends -->
  <ng-content></ng-content>

